import * as Accordion from "@radix-ui/react-accordion"
import { requestApi2 } from "@utils/http"
import { endpoints, OpModeSchemaWithModes } from "api"
import { useEffect, useState } from "react"
import SeempSchemaAccordion from "./SeempSchemaAccordion"
import { SeempSchemaConfigFE } from "./types"

export default function SeempSchemaConfig() {
	const [newSchemaLabel, setNewSchemaLabel] = useState("")
	const [newSchemaOpModeSchemaId, setNewSchemaOpModeSchemaId] = useState("")
	const [opModeSchemasWithModes, setOpModeSchemasWithModes] = useState<
		OpModeSchemaWithModes[] | null
	>([])
	const [seempSchemas, setSeempSchemas] = useState<SeempSchemaConfigFE[]>([])

	useEffect(() => {
		const fetchSchemas = async () => {
			// const opModeSchemasWithModes = await requestApi2(
			// 	endpoints.opModeConfigGetSchemasWithModes
			// )
			//setOpModeSchemasWithModes(opModeSchemasWithModes)
			const schemas = await requestApi2(endpoints.seempGetSchemas)
			// setSeempSchemas([...fakeData, ...(schemas ?? [])])
			setSeempSchemas([...(schemas ?? [])])
		}
		fetchSchemas()
	}, [])

	const handleAddNewSchema = async () => {
		if (newSchemaLabel === "" || newSchemaOpModeSchemaId === "") {
			alert("Please enter a schema name and select an op mode schema")
			return
		}

		try {
			const newSchema = await requestApi2(endpoints.seempAddSchema, {
				label: newSchemaLabel,
				opModeSchemaId: newSchemaOpModeSchemaId,
			})
			setSeempSchemas((prev) => (newSchema !== null ? [...prev, newSchema] : prev))
			alert("Schema added successfully")
			setNewSchemaLabel("")
			//setNewSchemaOpModeSchemaId("")
		} catch (error) {
			console.error("Error adding schema:", error)
			alert("Error adding schema")
		}
	}

	return opModeSchemasWithModes === undefined ? (
		"loading..."
	) : opModeSchemasWithModes === null ? (
		"error loading schemas"
	) : (
		<div className={`mt-3 flex w-full flex-col gap-8 border-t-1 py-4`}>
			<div className={`flex flex-col gap-2`}>
				<div className={`text-title3`}>Seemp schemas</div>
				<div className={`grid w-1/2 min-w-250 grid-cols-[1fr_auto_auto] gap-8`}>
					{/* <div className={`grid grid-cols-[auto_1fr] items-center gap-2`}>
						<label
							className={``}
							htmlFor="schema_label"
						>
							Schema name
						</label>
						<input
							className={`border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500 h-8 w-full rounded-sm border-1 px-2 outline-none focus:ring-1`}
							id="schema_label"
							value={newSchemaLabel}
							onChange={(e) => setNewSchemaLabel(e.target.value)}
							placeholder={"enter a name for the schema..."}
						/>
					</div> */}
					<div className={`grid grid-cols-[auto_1fr] items-center gap-2`}>
						{/* <select
						<label
							className={``}
							htmlFor="op_mode_schema"
						>
							Op mode schema
						</label>
							className={`border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500 h-8 !w-75 rounded-sm border-1 px-2 py-0 outline-none focus:ring-1`}
							id="op_mode_schema"
							onChange={(e) => setNewSchemaOpModeSchemaId(e.target.value)}
						>
							<option value={""}>Select op mode schema</option>
							{opModeSchemasWithModes
								.sort((a, b) => a.schemaId.localeCompare(b.schemaId))
								.map((schema) => (
									<option
										key={schema.schemaId}
										value={schema.schemaId}
									>
										{schema.schemaId} ({schema.opModes.length} op modes)
									</option>
								))}
						</select> */}
					</div>
					{/* <Button
						variant={"filled-primary"}
						onClick={handleAddNewSchema}
					>
						<Button.Label>Add </Button.Label>
					</Button> */}
				</div>
			</div>
			<div className={`flex flex-col`}>
				<Accordion.Root
					className="flex flex-col w-full gap-0"
					type="multiple"
					defaultValue={seempSchemas.map((s) => s.id.toString())}
				>
					{seempSchemas.map((schema) => (
						<SeempSchemaAccordion
							key={schema.id}
							schema={schema}
							opModeSchemasWithModes={opModeSchemasWithModes}
							setSeempSchemas={setSeempSchemas}
						/>
					))}
				</Accordion.Root>
			</div>
		</div>
	)
}
